import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { OverviewUtilizationCard, ChallengesUtilizationCard } from "../atoms"
import { OverviewSectionIcon } from '../../overview/OverviewSectionIcon'
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { commaingNumber } from "../../../utils"
import { SemiDonughnutGraph } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const HealthChallengeCard = ({ contractId, startDate, endDate, totalCustomerCount = 0, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()

  useEffect(() => {
    if (!contractId) return

    setState(prevState => { return { ...prevState, loading: true } })
    OverviewApi.fetchHealthChallengeOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({ ...res.data, loading: false })
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored = false, total_points_earned = 0, completed_challenges = 0, started_challenges = 0, employee_utilized_count = 0, loading } = state

  const tileEmployees = 'Employees who took challenges'
  const tileChallenges = 'Total challenges started & completed'
  const tilePoints = 'Total health points awarded'

  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-shadow duration-200 hover:shadow-md ${classes}`}
    >
      <div className='pb-4'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='flex min-w-0 flex-1 gap-3'>
            <OverviewSectionIcon name='health_challenges' className='mt-0.5' />
            <div className='min-w-0'>
              <div className='flex flex-wrap items-center gap-2'>
                <p className='mb-0 max-w-full text-base font-semibold leading-snug text-gray-800'>Health challenges</p>
                {sponsored && (
                  <span className='inline-flex shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700'>
                    Sponsored
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className='flex flex-shrink-0'>
            <button
              type='button'
              className='rounded-lg border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-800 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
              onClick={() => '/challenges' && history.push('/challenges')}
            >
              View insights
            </button>
          </div>
        </div>
      </div>
      {!loading ? (
        <div className='grid grid-cols-3 gap-6'>
          <div className='flex min-h-0 flex-col'>
            <SemiDonughnutGraph
              tileLabel={tileEmployees}
              linerStyles={employee_utilized_count?.toString().length > 5 ? 'w-7/12 text-center bottom-6' : 'bottom-11'}
              id='health-challenges-myChart'
              total={totalCustomerCount}
              completed={employee_utilized_count}
              title='Health challenges utilization'
              liner={
                <span>
                  <span className='text-sm font-semibold'>{employee_utilized_count}</span> out of {totalCustomerCount} employees
                </span>
              }
              graphClasses='-mt-8 -mb-4'
              classes='flex-1'
              metricValue='*includes only active employees'
            />
          </div>
          <div className='flex min-h-0 flex-col'>
            <ChallengesUtilizationCard
              tileLabel={tileChallenges}
              title1={commaingNumber(started_challenges)}
              title2={commaingNumber(completed_challenges)}
              liner1='Started'
              liner2='Completed'
              classes='flex-1 gap-12'
            />
          </div>
          <div className='flex min-h-0 flex-col'>
            <OverviewUtilizationCard
              tileLabel={tilePoints}
              title={
                <span className='mb-0 flex flex-row items-center gap-3 font-jetbrains-mono tabular-nums text-gray-900'>
                  <OverviewSectionIcon name='health_points' />
                  {commaingNumber(parseInt(total_points_earned, 10))}
                </span>
              }
              liner='Total health points awarded to your employees through challenges'
              classes='flex-1'
            />
          </div>
        </div>
      ) : (
        <div className='flex h-40 items-center justify-center'>
          <SpinnerDotted />
        </div>
      )}
    </div>
  )
}

export default HealthChallengeCard